<div class="header">

    <a class="logo" routerLink="/">
        <img src="../assets/logo.png" alt="WAGAS - Handlowcy">
        <span>Sales Support System</span>
    </a>

</div>
<ns-template-window>
    <div class="main">
        <div class="information-box">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
                <div class="description">
                    Ustaw nowe hasło
                </div>
                <cmn-label labelText="Hasło" labelPosition="top" labelWidth="100%">
                    <input type="password"
                           formControlName="newPassword"
                           autocomplete="off"
                           kendoTextBox/>
                    <cmn-errors [control]="form.get('newPassword')"></cmn-errors>

                </cmn-label>
                <div class="action-row">
                    <button type="submit"
                            kendoButton
                            [primary]="false"
                            class="mid"
                    >
                        Ustaw nowe hasło
                    </button>
                </div>
            </form>
        </div>
    </div>
</ns-template-window>
